import { withSearch } from '@elastic/react-search-ui';
import DropDownFilter from '../../../components/filter/DropDownFilter';

const ResearchReportsPeriodFilter = ({
  facets,
  filters,
  setFilter,
  removeFilter,
}) => {
  const optionsConfig = [
    {
      name: 'Prehistoric 1,000,000 BC to AD 43',
      value: 'Prehistoric',
      level: 0,
    },
    {
      name: 'Early Prehistoric 1,000,000 BC to 4000 BC',
      value: 'Early Prehistoric',
      level: 0,
    },
    {
      name: 'Palaeolithic 1,000,000 BC to 10,000 BC',
      value: 'Palaeolithic',
      level: 0,
    },
    {
      name: 'Lower Palaeolithic 1,000,000 BC to 150,000 BC',
      value: 'Lower Palaeolithic',
      level: 1,
    },
    {
      name: 'Middle Palaeolithic 150,000 BC to 40,000 BC',
      value: 'Middle Palaeolithic',
      level: 1,
    },
    {
      name: 'Upper Palaeolithic 40,000 BC to 10,000 BC',
      value: 'Upper Palaeolithic',
      level: 1,
    },
    { name: 'Mesolithic 10,000 BC to 4000 BC', value: 'Mesolithic', level: 0 },
    {
      name: 'Early Mesolithic 10,000 BC to 7000 BC',
      value: 'Early Mesolithic',
      level: 1,
    },
    {
      name: 'Late Mesolithic 7000 BC to 4000 BC',
      value: 'LATE MESOLITHIC',
      level: 1,
    },
    {
      name: 'Later Prehistoric 4000 BC to AD 43',
      value: 'Later Prehistoric',
      level: 0,
    },
    { name: 'Neolithic 4000 BC to 2200 BC', value: 'Neolithic', level: 0 },
    {
      name: 'Early Neolithic 4000 BC to 3300 BC',
      value: 'Early Neolithic',
      level: 1,
    },
    {
      name: 'Middle Neolithic 3300 BC to 2900 BC',
      value: 'Middle Neolithic',
      level: 1,
    },
    {
      name: 'Late Neolithic 2900 BC to 2200 BC',
      value: 'Late Neolithic',
      level: 1,
    },
    { name: 'Bronze Age 2600 BC to 700 BC', value: 'Bronze Age', level: 0 },
    {
      name: 'Early Bronze Age 2600 BC to 1600 BC',
      value: 'Early Bronze Age',
      level: 1,
    },
    {
      name: 'Middle Bronze Age 1600 BC to 1200 BC',
      value: 'Middle Bronze Age',
      level: 1,
    },
    {
      name: 'Late Bronze Age 1200 BC to 700 BC',
      value: 'Late Bronze Age',
      level: 1,
    },
    { name: 'Iron Age 800 BC to AD 43', value: 'Iron Age', level: 0 },
    {
      name: 'Early Iron Age 800 BC to 300 BC',
      value: 'Early Iron Age',
      level: 1,
    },
    {
      name: 'Middle Iron Age 300 BC to 100 BC',
      value: 'Middle Iron Age',
      level: 1,
    },
    { name: 'Late Iron Age 100 BC to AD 43', value: 'Late Iron Age', level: 1 },
    { name: 'Roman AD 43 to AD 410', value: 'Roman', level: 0 },
    {
      name: 'Early Medieval AD 410 to 1066',
      value: 'Early Medieval',
      level: 0,
    },
    {
      name: 'Anglo Saxon AD 410 to 1066',
      value: 'Anglo-Saxon',
      level: 0,
    },
    { name: 'Medieval 1066 to 1540', value: 'Medieval', level: 0 },
    { name: 'Post Medieval 1540 to 1901', value: 'Post Medieval', level: 0 },
    { name: 'Tudor 1485 to 1603', value: 'Tudor', level: 0 },
    { name: 'Elizabethan 1558 to 1603', value: 'Elizabethan', level: 0 },
    { name: 'Stuart 1603 to 1714', value: 'Stuart', level: 0 },
    { name: 'Jacobean 1603 to 1625', value: 'Jacobean', level: 0 },
    { name: 'Hanoverian 1714 to 1837', value: 'Hanoverian', level: 0 },
    { name: 'Georgian 1714 to 1830', value: 'Georgian', level: 0 },
    { name: 'Victorian 1837 to 1901', value: 'Victorian', level: 0 },
    { name: '20th Century 1901 to 2000', value: '20th Century', level: 0 },
    {
      name: 'Early 20th Century 1901 to 1932',
      value: 'Early 20th Century',
      level: 1,
    },
    { name: 'Edwardian 1902 to 1910', value: 'Edwardian', level: 1 },
    {
      name: 'First World War 1914 to 1918',
      value: 'First World War',
      level: 1,
    },
    {
      name: 'Mid 20th Century 1933 to 1966',
      value: 'Mid 20th Century',
      level: 1,
    },
    {
      name: 'Second World War 1939 to 1945',
      value: 'Second World War',
      level: 1,
    },
    { name: 'Cold War 1946 to 1991', value: 'Cold War', level: 1 },
    {
      name: 'Late 20th Century 1967 to 2000',
      value: 'Late 20th Century',
      level: 1,
    },
    { name: '21st Century 2001 to 2100', value: '21st Century', level: 0 },
    { name: 'Modern', value: 'MODERN' },
    { name: 'Uncertain', value: 'Uncertain' },
    {
      name: 'Early Med. Or Later (410AD - 1540AD)',
      value: 'EARLY MED. OR LATER',
    },
    {
      name: 'Prehistoric Or Roman (500000BC - 410AD)',
      value: 'PREHISTORIC OR ROMAN',
    },
  ];

  const options = [];
  const facetResultMap = {};
  const fieldId = 'period';

  if (
    facets[fieldId] &&
    facets[fieldId].length > 0 &&
    facets[fieldId][0].data.length > 0
  ) {
    facets[fieldId][0].data.forEach(facet => {
      facetResultMap[facet.value] = facet;
    });
  }

  optionsConfig.forEach(optionConfig => {
    const matchingFacet = facetResultMap[optionConfig.value];

    if (matchingFacet) {
      options.push({
        name: optionConfig.name,
        value: optionConfig.value,
        count: matchingFacet.count,
        level: optionConfig.level,
      });
      delete facetResultMap[optionConfig.value];
    }
  });

  Object.keys(facetResultMap).forEach(remainingFacetKey => {
    options.push({
      name: facetResultMap[remainingFacetKey].value,
      value: facetResultMap[remainingFacetKey].value,
      count: facetResultMap[remainingFacetKey].count,
      level: 0,
    });
  });

  return (
    <DropDownFilter
      fieldId="period"
      filters={filters}
      id="period"
      label="Historic period"
      options={options}
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
};

export default withSearch(({ facets, filters, setFilter, removeFilter }) => ({
  facets,
  filters,
  setFilter,
  removeFilter,
}))(ResearchReportsPeriodFilter);
